import { z } from 'zod'
import { ValueObject } from '@lukso/controllerapps-sharedlogic-ddd-core'
import { HexNumber } from '@lukso/controllerapps-sharedlogic-primitives'

const TransactionValuePropsSchema = z.object({
  transactionValueValue: z.instanceof(HexNumber),
})

type TransactionValueProps = z.infer<typeof TransactionValuePropsSchema>

export class TransactionValue extends ValueObject<TransactionValueProps> {
  /**
   * @returns A 0x-prefixed hex string.
   */
  public getHexValue(): string {
    return this.props.transactionValueValue.getValue()
  }

  public static create(transactionValueValue: HexNumber): TransactionValue {
    const validatedProps = TransactionValuePropsSchema.parse({
      transactionValueValue,
    })
    return new TransactionValue(validatedProps)
  }
}
